/** Matches startups3 `ADVISOR_WIL_TOOL_SLUG` (apps/startups3-app/src/sco/reference/advisor-tools.js). */
export const ADVISOR_WIL_TOOL_SLUG = 'advisor-wil'

/**
 * Wil Onboarding — sales/intake clone of Wil.ai.
 * Seed: startups3 `upsertWilOnboardingTool` script (slug `wil-onboarding`).
 * Prefer this for homepage SignupRequestChatIntake once the tool row exists.
 */
export const WIL_ONBOARDING_TOOL_SLUG = 'wil-onboarding'

/**
 * Default tool for public homepage intake chat.
 * Flipped to wil-onboarding after seed (interactive questions + anonymous sessions).
 * Override via SignupRequestChatIntake `toolSlug` prop if needed.
 */
export const INTAKE_DEFAULT_TOOL_SLUG = WIL_ONBOARDING_TOOL_SLUG
